// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PolicyReporterV1ClientGeneratedIdentifierType } from './policyReporterV1ClientGeneratedIdentifierType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsRequestTypesGetMedicareReportRequestModel {
    'identifierType'?: PolicyReporterV1ClientGeneratedIdentifierType;
    'identifierValue'?: string | null;
    'prescriberState'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsRequestTypesGetMedicareReportRequestModel>> = [
        {
            "name":     "identifierType",
            "baseName": "identifierType",
            "type":     "PolicyReporterV1ClientGeneratedIdentifierType"
        },
        {
            "name":     "identifierValue",
            "baseName": "identifierValue",
            "type":     "string"
        },
        {
            "name":     "prescriberState",
            "baseName": "prescriberState",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsRequestTypesGetMedicareReportRequestModel.attributeTypeMap;
    }
}
